<div class="web-links-container" *ngIf="showComponent">
  <div class="web-links-header">
    <strong>Ссылки на веб-страницы</strong>
    <nb-icon icon="plus-circle-outline" (click)="openForm()"></nb-icon>
  </div>
  <div class="web-links" *ngIf="links">
    <div *ngFor="let link of links">
      <nb-icon icon="globe-2-outline"></nb-icon>
      <a [href]="link.url" target="_blank">{{ link.header.length ? link.header : link.url }}</a>

      <button nbButton ghost type="button" size="tiny"
              [nbPopover]="confirm"
              [nbPopoverContext]="{link: link}">
        <nb-icon icon="trash-outline"></nb-icon>
      </button>
    </div>
  </div>
  <form [formGroup]="form" *ngIf="showForm" (ngSubmit)="onSubmit()">
    <div class="web-links-form">
      <div class="web-link">
        <label>URL</label>
        <input #linkInput nbInput fullWidth formControlName="url" placeholder="http://crm.compo-soft.ru"/>
      </div>
      <div class="web-title">
        <label>Текст ссылки</label>
        <input nbInput fullWidth formControlName="header" placeholder="Добавить описание..."/>
      </div>
    </div>
    <div class="web-link-buttons">
      <button nbButton size="small" status="primary" [disabled]="!form.valid || loading" [nbSpinner]="loading">Связать</button>
      <button nbButton size="small" status="basic" type="button" (click)="closeForm()">Отмена</button>
    </div>
  </form>
</div>

<ng-template #confirm let-data>
  <nb-card style="padding: 0 20px">
    <nb-card-header>Удалить ссылку?</nb-card-header>
    <nb-card-body style="margin-top: 20px">
      <button nbButton status="danger" size="small" (click)="deleteLink(data.link)">Удалить</button>&nbsp;&nbsp;
      <button nbButton ghost status="basic" size="small" (click)="closeConfirm()">Отмена</button>
    </nb-card-body>
  </nb-card>
</ng-template>
